var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.471 0.247)"},[React.createElement("circle",{"cx":"66","cy":"66","r":"66","transform":"translate(-0.471 -0.247)","fill":"#d7b368","key":0}),React.createElement("path",{"d":"M18.5,0,37,32H0Z","transform":"translate(87.529 47.753) rotate(90)","fill":"#fff","key":1})]));
}

PlayButton.defaultProps = {"width":"132","height":"132","viewBox":"0 0 132 132"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
